import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import localforage from 'localforage'

// let url = 'http://127.0.0.1:8090'
let url = 'http://47.112.114.226'
// let url = 'http://106.52.58.161'
// let url = 'http://192.168.1.154:8095'
// let url = 'http://192.168.3.5:8090'
// 物流网test
// let url = 'http://192.168.3.88:9001'
// 小李
// let url = 'http://192.168.3.191:8090'
// 公司
// let url = 'http://192.168.3.201:8090'
// function getToken(){

//   let token=JSON.parse(localStorage.getItem('tokenArr231'))
//   if(token){
//     return token;
//   }else{
//     return token=["",""]
//   } 
// }
// function getUUid(){
//   let UUid="ss"
//   UUid=localStorage.getItem('UUid');np
//   return UUid;
// }

// 创建axios实例
const axiosInstance = axios.create({
  baseURL: url,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8;multipart/form-data',
}, // 设置传输内容的类型和编码
  withCredentials: true // 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
})

// request拦截器
axiosInstance.interceptors.request.use(config => {
  console.log(config)
  let token = JSON.parse(localStorage.getItem('tokenArr231'))==null?"":JSON.parse(localStorage.getItem('tokenArr231'))[0]
    if (token) {
        config.headers.token = token //token  是请求头要求加上的字段
    }
    let uuid = JSON.parse(localStorage.getItem('tokenArr231'))==null?"":JSON.parse(localStorage.getItem('tokenArr231'))[1]
    if (uuid) {
        config.headers.uuid = uuid //token  是请求头要求加上的字段
    }
  return config
}, error => {
  console.log(error)
  Promise.reject(error).then(r => console.log(r))
})

// response拦截器
axiosInstance.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 708 || res.code === 901 || res.code === 600 || res.code === 910 || res.code === 710) {
      Message({
        message: res.message,
        type: 'warning',
        duration: 1000
      })
      return Promise.reject(res)
    } else if (res.code === 200 || res.code === 711) {
      return response.data
    } else if (res.code === 500) {
      Message({
        message: '系统繁忙，请稍后重试！',
        type: 'error',
        duration: 1000
      })
      return Promise.reject(res)
    } else if (res.code === 709) {
      Message({
        message: res.message,
        type: 'error',
        customClass: 'login-error',
        duration: 1000
      })
      return Promise.reject(res)
    } else if (res.code === 913) { // 超过60天数修改密码
      return response.data
    }
  },
  (error) => {
    console.log(error.response)
    if (error.response) {
      if (error.response.data.code === 705) { // 用户未登录
        store.dispatch('changeMessage', '用户未登录，请重新登录！')
      } else if (error.response.data.code === 914) { // 用户已在别处登录
        store.dispatch('changeMessage', '用户已在别处登录，请重新登录！')
      } else if (error.response.data.code === 915) { // 登录超时
        store.dispatch('changeMessage', '登录超时，请重新登录！')
      } else if (error.response.data.code === 912) { // 超过90天数修改密码
        Message({
          message: error.response.data.message,
          type: 'error',
          customClass: 'login-error',
          duration: 2000
        })
      } else if (error.response.data.code === 916) { // 错误超限已冻结账户，请联系管理员解除
        Message({
          message: error.response.data.message,
          type: 'error',
          customClass: 'login-error',
          duration: 2000
        })
      } else {
        Message({
          message: '系统繁忙，请稍后重试！',
          type: 'error',
          duration: 1000
        })
      }
    } else {
      Message({
        message: '系统繁忙，请稍后重试！',
        type: 'error',
        duration: 1000
      })
    }
    return Promise.reject(error)
  }
)
export default axiosInstance



// WEBPACK FOOTER //
// ./src/tools/request.js